import { BaseQCOperator } from '90.quickConnect.Models/models';

const mapVisibilityOnDevice = (visibility: string | boolean | BaseQCOperator | undefined): boolean | undefined => {
  if (typeof visibility === 'boolean') return visibility;
  if (visibility === 'FalseOnDevice') return false;
  else return undefined;
};

export default mapVisibilityOnDevice;
